<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
            {{ $t('select_delivery_time') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-list class="list-delivery_time">
          <template v-for="(item, idx) in delivery_time">
            <v-list-item :key="idx" :disabled="disabled[idx]" @click="goTo(item.ftime)">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.ftime }}
                  <template v-if="$store.state.selected_store.delivery.unlimited_items_order === 0">
                    <span v-if="item.order_left < 6" class="soft-grey--text font-weight-light">
                      ( {{ item.order_left }} order left )
                    </span>
                  </template>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="idx + 'divider'" />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  delieverytimes as getDelieveryTimes
} from '@/api/setting'
export default {
  data() {
    return {
      disabled: [],
      delivery_time: [],
      dataCheckoutDelivery: {
        shipping_address: '',
        shipping_delivery_type: 1,
        shipping_time: '',
        shipping_radius: 0,
        item: []
      }
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))) this.dataCheckoutDelivery = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY'))
    this.getListTime()
  },
  methods: {
    async getListTime() {
      const today = new Date()
      const curDay = today.getDay() + 1
      try {
        const { data } = await getDelieveryTimes(curDay)
        this.$store.state.loading_axios = false
        this.delivery_time = data.data.times
        for (var i = 0; i < this.delivery_time.length; i++) {
          if (this.$store.state.selected_store.delivery.unlimited_items_order === 0) {
            if (this.delivery_time[i].order_left === 0 || this.delivery_time[i].time_has_passed === 1) {
              this.disabled[i] = true
            } else {
              this.disabled[i] = false
            }
          } else {
            if (this.delivery_time[i].time_has_passed === 1) {
              this.disabled[i] = true
            } else {
              this.disabled[i] = false
            }
          }
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    goBack() {
      this.$router.push({ name: 'delivery_method' }).catch(() => {})
    },
    goTo(shipping_time) {
      this.dataCheckoutDelivery.shipping_time = shipping_time
      this.$store.dispatch('saveDataCartDelivery', this.dataCheckoutDelivery)
      this.$router.push({ name: 'checkout' }).catch(() => {})
    }
  }
}
</script>
